/**
 * Erreur explicite levee quand la configuration runtime ne peut pas etre
 * chargee ou validee. Distincte des erreurs generiques pour permettre aux
 * consommateurs (shell, apps) d'afficher un ecran d'erreur dedie.
 */
export class TakiConfigError extends Error {
  override readonly name = "TakiConfigError";

  /** Cause sous-jacente (erreur reseau, JSON invalide, etc.), si disponible. */
  override readonly cause?: unknown;

  constructor(message: string, options?: { cause?: unknown }) {
    super(message);
    this.cause = options?.cause;
    // Restaure la chaine de prototype apres `super` (cible ES down-level safe).
    Object.setPrototypeOf(this, TakiConfigError.prototype);
  }
}
